import React, { useState, useEffect } from 'react';
import { I18n } from '@kineticdata/react';
import { ActivityNode } from './activity_nodes/ActivityNode';
import { parseActivityData } from '../../utils';
import classNames from 'classnames';

const ToggleAllButton = ({ isOpen, toggle }) => (
  <button className="btn btn-text" onClick={toggle}>
    <span
      className={classNames('fa fa-fw fa-md text-muted', {
        'fa-plus': !isOpen,
        'fa-minus': isOpen,
      })}
    />
    <span>
      <I18n>{!isOpen ? 'Expand All' : 'Collapse All'}</I18n>
    </span>
  </button>
);

export const RequestActivityList = ({ submission }) => {
  // Filter activities to remove comments
  const activities = submission.activities.filter(a => a.type !== 'Comment');
  // Get count of activities
  const activityCount = activities.length;
  // State for tracking which activities are expanded
  const [openActivityList, setOpenActivityList] = useState(
    new Array(activityCount).fill(activityCount <= 3),
  );
  // Size of state array for tracking open activities
  const openActivityCount = openActivityList.length;
  // FLag checking if all activities are expanded
  const isAllActivityOpen = !openActivityList.some(o => !o);
  // Effect that rebuilds the open activities array state if the number of
  // activities changes due to polling and more being fetched
  useEffect(
    () => {
      if (activityCount > openActivityCount) {
        setOpenActivityList(list => [
          ...list,
          ...new Array(activityCount - openActivityCount).fill(
            activityCount <= 3,
          ),
        ]);
      }
    },
    [activityCount, openActivityCount],
  );
  // Function that returns a handle for toggling an activity at a specific index
  const toggleActivity = i => () =>
    setOpenActivityList(list => {
      const toggledList = [...list];
      toggledList.splice(i, 1, !list[i]);
      return toggledList;
    });
  // Handler for toggling all activity records
  const toggleAllActivity = () =>
    setOpenActivityList(new Array(openActivityCount).fill(!isAllActivityOpen));

  return (
    <ul className="activity" role="tabpanel">
      <li className="activity__meta activity__meta--start">
        <div className="badge badge-pill badge-subtle">
          <I18n>Started</I18n>
        </div>
        {activityCount > 0 && (
          <ToggleAllButton
            isOpen={isAllActivityOpen}
            toggle={toggleAllActivity}
          />
        )}
      </li>
      <li className="activity__spacer" aria-hidden="true" />
      {(activityCount > 0
        ? activities
        : [{ label: 'No Activity', id: 'no-activity' }]
      )
        .map(activity => ({
          activity,
          data: parseActivityData(activity),
          submission,
          key: activity.id,
        }))
        .map((props, i) => (
          <ActivityNode
            {...props}
            isOpen={!!openActivityList[i]}
            toggle={toggleActivity(i)}
          />
        ))}
      <li className="activity__spacer" aria-hidden="true" />
      <li className="activity__meta activity__meta--end">
        <div
          className={classNames('badge badge-pill', {
            'badge-subtle': submission.closedAt,
            'badge-info badge-muted': !submission.closedAt,
          })}
        >
          <I18n>{submission.closedAt ? 'Finished' : 'In Progress'}</I18n>
        </div>
        {activityCount > 0 && (
          <ToggleAllButton
            isOpen={isAllActivityOpen}
            toggle={toggleAllActivity}
          />
        )}
      </li>
    </ul>
  );
};
